import React, { forwardRef, useCallback, useEffect, useState, } from 'react';
import isFunction from 'lodash/isFunction';
import { Success } from '@yme/assets/icons';
import { INPUT_STATE_SUCCESS } from './constants';
import { InfoTextStyled, InputContainer, InputStyled, InputWrapper, LabelStyled } from './styled';
const LEFT_ICON_SUCCESS = {
    leftIcon: Success,
};
const RIGHT_ICON_SUCCESS = {
    rightIcon: Success,
};
export const Input = forwardRef((props, inputRef) => {
    const { id = '', name, type = 'text', changeHandler, blurHandler, focusHandler, label, ariaLabel, isTextarea, placeholder = '', infoText, leftIcon, rightIcon, multipleIconsBlock, value = '', state, isDisabled, isRightToLeft, maxLength, customPadding = 0, isRequired = false, dropdown, autoComplete = 'off', autoCorrect = 'off', autoCapitalize = 'off', onKeyDownHandler, className, dataTestId, isLabelVisible = true, isFullWidth, tabIndexWrapper, isFocused = false, keepMsgPlaceholder = false, } = props;
    const showInfoText = keepMsgPlaceholder ? true : infoText && infoText.length > 0;
    const [icons, setIcons] = useState({
        leftIcon,
        rightIcon,
    });
    const onInputChange = useCallback((e) => {
        changeHandler?.(e.target.value);
    }, [changeHandler]);
    const onFocusHandler = useCallback((e) => {
        focusHandler?.(e);
    }, [focusHandler]);
    const onBlurHandler = useCallback((e) => {
        blurHandler?.(e);
    }, [blurHandler]);
    useEffect(() => {
        if (isFocused && !isFunction(inputRef) && inputRef?.current) {
            inputRef?.current.focus();
        }
    }, [inputRef, isFocused]);
    useEffect(() => {
        setIcons({
            leftIcon,
            rightIcon,
        });
        if (isRightToLeft) {
            setIcons({
                leftIcon: rightIcon,
                rightIcon: leftIcon,
            });
        }
        if (state === INPUT_STATE_SUCCESS) {
            setIcons(isRightToLeft ? LEFT_ICON_SUCCESS : RIGHT_ICON_SUCCESS);
        }
    }, [isRightToLeft, leftIcon, rightIcon, state]);
    return (React.createElement(InputContainer, { isDisabled: isDisabled, isRightToLeft: isRightToLeft, className: className, isFullWidth: isFullWidth },
        isLabelVisible && label && (React.createElement(LabelStyled, { isRightToLeft: isRightToLeft, isRequired: isRequired, htmlFor: id }, label)),
        React.createElement(InputWrapper, { leftIcon: icons.leftIcon, rightIcon: icons.rightIcon, isDisabled: isDisabled, tabIndex: tabIndexWrapper },
            dropdown,
            React.createElement(InputStyled, { isTextarea: isTextarea, as: isTextarea ? 'textarea' : 'input', ref: inputRef, autoComplete: autoComplete, autoCorrect: autoCorrect, autoCapitalize: autoCapitalize, type: type, id: id, name: name, placeholder: placeholder, isLeftIcon: Boolean(icons.leftIcon), isRightIcon: Boolean(icons.rightIcon), onChange: onInputChange, onBlur: onBlurHandler, onFocus: onFocusHandler, state: state, value: value, isInputChanged: value.length > 0, disabled: isDisabled, customPadding: customPadding, maxLength: maxLength, onKeyDown: onKeyDownHandler, "data-testid": dataTestId, "aria-label": ariaLabel }),
            multipleIconsBlock && multipleIconsBlock),
        showInfoText && React.createElement(InfoTextStyled, { state: state },
            infoText,
            "\u00A0")));
});
Input.displayName = 'Input';
